import { TPage } from '../../types/analytics';
import { TApplicationState } from '../../types/redux';

export const selectPage = (state: TApplicationState): TPage => {
  return state.analytics.page;
};
